import api from '@/services/api'

export default {
  fetchAnounces () {
        return api().get('/anounces')
   
  },
  fetchNewAnounces () {
    return api().get('/anounces/new')

  },


  fetchVideos () {
    return api().get('/videos')

  },

  fetchNewVideos () {
     return api().get('/videos/new')

  },



  fetchEntities () {
    return api().get('/entities')
  },

  
  fetchPhoto () {
    return api().get('/photos')
  },

  fetchNewPhoto () {
    return api().get('/photos/new')
  },



  fetchMembers () {
    return api().get('/members')
  },


  fetchNewMembers () {
    return api().get('/members/new')

  },

  fetchOldMembers () {
    return api().get('/members/old')

  },

  addNewAnounce (id1, name1, date1, text1) {
  
  let ano = {
    Id: id1,
    Name: name1,
    Date: date1,
    Text: text1
  }

  api().post('anounces', ano ).then(function(res)  {
    console.log(res);
  }).catch(function(error){
    console.log(error);
  })
}


}
